module.exports = __webpack_public_path__ + "static/media/number_icon.ee7315d0.jpg";